import React, { useState, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Paper, Typography, Tabs, Tab, Select, MenuItem, IconButton } from '@mui/material';
import { ArrowBack } from "@mui/icons-material";
import Grid from '@mui/material/Grid2';
import config from '../config.js';
import AppContext from '../components/AppContext.js'; 
import Saldo from '../components/common/Saldo.js';
import { listMesos } from '../functions/common-lists.js';
import DataLoader from '../components/common/DataLoader.js';
import useBack from '../hooks/useBack.js';
import AnualBalanceListGlobal from '../components/dashboard-anual/AnualBalanceListGlobal.js';
import ConceptHierarchyList from '../components/common/ConceptHierarchyList.js';

const DashboardMensualGlobal = () => {
  const { setCtxApp } = useContext(AppContext);
  const [tabValue, setTabValue] = useState(0);
  const navigate = useNavigate();

  const { userapp: paramUserapp, mes: paramMes } = useParams();
  const userapp = paramUserapp;
  const mes = paramMes;
  const id = mes;

  const { onBack } = useBack();

  const gotoBack = () => {
    //navigate(`/${userapp}/dashboard/${anyo}`);
    onBack();
  }; 

  
  const handleMonth = (mes) => {
    navigate(`/${userapp}/dashboard/mes/${mes}`, { replace: true });
  };   


  const gotoDetail= (anio) => {
    setCtxApp(prev => ({ ...prev, dashboardMensualTabSelected: undefined }));
    navigate(`/${userapp}/dashboard/${anio}/mes/${mes}`);
  }  

  const fetchFunction = (jwtToken, onData, onError, onFinally) => {
    axios.get(`${config.apiBaseUrl}/v1/resumglobalmes/${userapp}/${mes}`, {
      headers: { Authorization: `${jwtToken}`}
    })
    .then((response) => {
      onData(response);
    })
    .catch((err) => {
      onError(err, 'cargar datos');
    })
    .finally(() => onFinally());
  };

  return (
    <DataLoader id={id} fetchFunction={fetchFunction} goBackLocation={`/${userapp}/dashboard`} >
      {(data) => {
        return (
        <>
          <Grid 
            size={{xs: 12, sm: 6 }} 
            sx={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '10px' }}
          >
            <IconButton onClick={()=>gotoBack()}>
              <ArrowBack />
            </IconButton>

            <Typography variant="h5">
              Dashboard Mensual Global
            </Typography>
            <Select
              value={data.mes}
              label="Mes"
              onChange={(e) => handleMonth(e.target.value)}
            >
              {listMesos.map((mes) => (
                <MenuItem key={mes.key} value={mes.key}>
                  {mes.name}
                </MenuItem>
              ))}
            </Select>
          </Grid>

          <Grid container spacing={2} sx={{ marginTop: '10px' }}>
            <Saldo titol="Saldo Global Mensual" 
              saldo={data.agregat.importAgregat.saldo} 
              ingressos={data.agregat.importAgregat.ingressos}
              despeses={data.agregat.importAgregat.despeses} 
              size={{xs: 12, sm: 6, md: 4 }}
            />

            <Saldo titol="Mitja Anual" 
              saldo={data.agregat.importAgregat.mitjaSaldo} 
              ingressos={data.agregat.importAgregat.mitjaIngressos}
              despeses={data.agregat.importAgregat.mitjaDespeses} 
              size={{xs: 12, sm: 6, md: 4 }}
            />
          </Grid>

          <Grid container spacing={2} sx={{ marginTop: '10px' }}>
            {/* Tabbar */}
            <Grid size={12}>
              <Paper>
                <Tabs value={tabValue} onChange={(e, val) => setTabValue(val)} indicatorColor="primary" textColor="primary" centered>
                  <Tab label="Anys" />
                  <Tab label="Conceptes (Jeràrquic)" />
                </Tabs>

                {tabValue === 0 && (
                  <AnualBalanceListGlobal years={data.mapAgregatAnual} gotoDetail={gotoDetail}/>
                )}
                {tabValue === 1 && (
                  <ConceptHierarchyList userapp={userapp} mes={data.mes} tipus="global" />
                )}
              </Paper>
            </Grid>
          </Grid>
      </>
      );
    }}
    </DataLoader>
  );
};

export default DashboardMensualGlobal;
